export const family = [
  { id: "seth", name: "Seth", role: "Adult", initials: "SC", color: "forest" },
  { id: "lara", name: "Lara", role: "Adult", initials: "LC", color: "coral" },
  { id: "watson", name: "Watson", role: "Child", initials: "W", color: "sky" },
  { id: "bennet", name: "Bennet", role: "Child", initials: "B", color: "gold" },
  { id: "montgomery", name: "Montgomery", role: "Young child", initials: "M", color: "mint" },
  { id: "claire", name: "Claire", role: "Executive assistant", initials: "C", color: "plum" },
  { id: "karis", name: "Karis", role: "Household helper", initials: "K", color: "rose" },
] as const;

export const timeline = [
  { time: "7:45 AM", title: "School drop-off", person: "Watson + Bennet", owner: "Needs driver", tone: "alert" },
  { time: "10:30 AM", title: "Piano home visit", person: "Watson", owner: "Confirm time", tone: "warn" },
  { time: "3:30 PM", title: "Band practice", person: "Watson", owner: "Seth driving", tone: "sky" },
  { time: "5:45 PM", title: "Dinner at home", person: "Everyone", owner: "Meal undecided", tone: "forest" },
] as const;

export const tasks = [
  { title: "Buy four-digit lock for trumpet case", owner: "Seth", due: "No date", priority: "high" },
  { title: "Confirm piano visit and safe entry", owner: "Unassigned", due: "Today", priority: "urgent" },
  { title: "Inspect insecure bedroom window", owner: "Seth", due: "This week", priority: "high" },
  { title: "Reconnect HUP cleaning device", owner: "Karis", due: "Next visit", priority: "normal" },
] as const;

export const proposals = [
  {
    id: "proposal-lock",
    type: "Task",
    title: "Buy a four-digit combination lock for Watson's trumpet case",
    owner: "Seth",
    confidence: 96,
    evidence: "I just need the one that has four numbers on it.",
    source: "Household transcript",
    sensitivity: "Household",
  },
  {
    id: "proposal-piano",
    type: "Clarification",
    title: "Confirm the date and safe-entry plan for the piano visit",
    owner: "Lara",
    confidence: 71,
    evidence: "They might come Monday morning, but I need to check.",
    source: "Household transcript",
    sensitivity: "Security",
  },
  {
    id: "proposal-window",
    type: "Maintenance",
    title: "Inspect the bedroom window that may not lock securely",
    owner: "Seth",
    confidence: 91,
    evidence: "That window still doesn't latch right.",
    source: "Household transcript",
    sensitivity: "Security",
  },
] as const;

